import Vue from 'vue';
import { mapMutations } from 'vuex';

export default Vue.extend({
  name: 'ApiMixin',

  methods: {
    showApiMessage(type = 'info', message, title, options) {
      const h = this.$createElement;

      let messageIcon = null;

      switch (type) {
        case 'success':
          messageIcon = h('i', { class: ['fas', 'fa-check'] });
          break;
        case 'warning':
          messageIcon = h('i', { class: ['fas', 'fa-exclamation'] });
          break;
        case 'error':
          messageIcon = h('i', { class: ['fas', 'fa-times'] });
          break;
        case 'info':
          messageIcon = h('i', { class: ['fas', 'fa-info'] });
          break;
        default:
          messageIcon = h('i', { class: ['fas', 'fa-info'] });
          break;
      }

      let messageVNode ;
      // More complex structure
      if(message.indexOf('<br>')>-1){
        let m =[];

        //Title處理
        if(title != '' && title != undefined && title != null){
          m.push( ( h('div', { class: ['modal-alert-title'] }, [title]) ) );
        }

        //訊息處理
        const messageArr = message.split('<br>');
        messageArr.forEach(element => {
          // console.log(`element:${element}`);
          let ct =[];

          if(element.indexOf('&fa-check') > -1){
            element = element.replace('&fa-check','');
            ct.push( element );
            ct.push( h('i', { class: ['fas', 'fa-check','text-success'] } ) );
          }else{
            ct.push( element );
          }

          m.push( ( h('div', { class: ['modal-alert-message'] }, [ct]) ) );
        });

        // 結構定義 h('div', { class: ['foobar'] }, [ title , msg ] }); < foobar 是外圈
        messageVNode = h('div', { class: ['foobar'] }, m );
      }else{
        messageVNode =  h('div', { class: ['foobar'] }, [ h('div', { class: ['modal-alert-icon'] }, [messageIcon]), title ? h('h4', { class: ['modal-alert-title'] }, [title]) : null, message ? h('div', { class: ['modal-alert-message'] }, [message]) : null, ]);

      }


      // We must pass the generated VNodes as arrays
      if (options && options.confirm === true) {
        return this.$bvModal.msgBoxConfirm([messageVNode], {
          centered: true,
          hideHeader: true,
          okVariant: 'action',
          okTitle: '確定',
          cancelTitle: '取消',
          cancelVariant: 'outline-secondary',
          modalClass: ['modal-alert', `modal-alert-${type}`],
          footerClass: 'modal-alert-actions text-center justify-content-center flex-row-reverse',
          ...options,
        });
      }

      return this.$bvModal.msgBoxOk([messageVNode], {
        centered: true,
        hideHeader: true,
        okVariant: 'action',
        okTitle: '確定',
        modalClass: ['modal-alert', `modal-alert-${type}`],
        footerClass: 'modal-alert-actions text-center justify-content-center',
        ...options,
      });
    },

    ...mapMutations({
      apiStart: 'api/start',
      apiStop: 'api/stop',
    }),
  },
});
